import * as React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Store } from 'redux';
import { History } from 'history';
import Routes from './routes';
import ThemeProvider from './components/themeProvider';
import { ApplicationState } from './store';
import './styles/core.scss';
import 'normalize.css';
import { useTabIdKey } from './hooks/useTabIdKey';

// Any additional component props go here.
interface MainProps {
  store: Store<ApplicationState>;
  history: History;
}

// Create an intersection type of the component props and our Redux props.
const Main: React.FC<MainProps> = (props: MainProps) => {
  useTabIdKey();
  const { store, history } = props;
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider>
          <Routes />
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default Main;
